import React from 'react';
import MainBanner from '../Nfts/MainBanner';
import Speakers from '../Nfts/SpeakersTwo';
import Footer from '../Common/Footer';
 
class SpeakersTwo extends React.Component {
    render(){
        return (
            <React.Fragment>
                <MainBanner />
                <Speakers />
                <Footer />
            </React.Fragment>
        );
    }
}
 
export default SpeakersTwo;